import { h, Component } from 'preact';
import { route } from 'preact-router';
import { BaseComponent } from '../../common/BaseComponent';
import { ISignInOutProps, ISignInOutState } from './ISignInOut';

import Button from 'preact-material-components/Button';
import { bind } from 'decko';
import { Questions } from '../../components/Questions/Questions';
import { SignInOutQuestions } from '../../models/SignInOutQuestions';
import { SignInOutRequest } from '../../models/SignInOutRequest';
import { Question } from '../../models/Question';
import { ServiceResult } from '../../models/ServiceResult';

import { VideoPlayer } from '../../components/videoPlayer/videoPlayer'
import { DocViewer } from '../../components/docViewer/docViewer';
import { UserTypeEnum } from '../../enums/UserTypeEnum';

let style = require('./style.scss');

export class SignInOut extends BaseComponent<ISignInOutProps, ISignInOutState> {

    public refs: { questions?: Questions, video: VideoPlayer, doc: DocViewer };

    public processSignInOut: (SignInOutRequest) => Promise<ServiceResult<SignInOutQuestions>>;
    public signInOut: (request: SignInOutRequest) => Promise<ServiceResult<SignInOutQuestions>>;

    public longitude: number;
    public latitude: number;

    constructor(props, ctx) {
        history.replaceState(null, "myBuildings Sign In", "/");
        super(props, ctx);
        this.longitude = 0;
        this.latitude = 0;
        this.setState({
            isLoading: true
        });

        if (this.props.isSignIn) {
            this.processSignInOut = this.buildingService.processSignIn.bind(this.buildingService);
            this.signInOut = this.buildingService.signIn.bind(this.buildingService);
        }
        else {
            this.processSignInOut = this.buildingService.processSignOut.bind(this.buildingService);
            this.signInOut = this.buildingService.signOut.bind(this.buildingService);
        }
    }

    @bind
    public onSignInOut() {

        var answers = [];
        if (this.state.questions && this.state.questions.questions && this.state.questions.questions.length)
            for (const key in this.refs.questions.answers) {
                var ans = this.refs.questions.answers[key];
                if (ans.required && !ans.answerIds && ans.isChecked === undefined && !ans.text) {
                    this.modal.alert("Please ensure you have answered all questions");
                    return;
                }
                answers.push(ans);
            }
        this.setState({ isLoading: true });

        this.modal.showLoader(this.processSignInOut(new SignInOutRequest({ answers: answers, buildingId: this.props.buildingId, questionInfo: this.state.questions.questionInfo, latitude: this.latitude, longitude: this.longitude })))
            .then(r => {
                this.commonService.setHeaderImage(r.result.useHeaderImage);
                this.commonService.setFooterImage(r.result.useFooterImage);
                if (r.errorMessage && (!r.result || !r.result.questions || !r.result.questions.length)) {
                    this.modal.alert(r.errorMessage);
                    return;
                }
                if (r.result.questions && r.result.questions.length > 0) {
                    this.setState({ questions: r.result, isLoading: false });
                    if (r.infoMessage) this.modal.alert(r.infoMessage, () => {
                        setTimeout(() => {
                            this.showDocToDisplay(r.result);
                        }, 500)
                    });
                    else if (r.errorMessage) this.modal.alert(r.errorMessage, () => {
                        setTimeout(() => {
                            this.showDocToDisplay(r.result);
                        }, 500)
                    });
                    else this.showDocToDisplay(r.result);

                }
                else if (r.infoMessage)
                    this.modal.alert(r.infoMessage, () => {
                        if (!r.errorMessage) {
                            route("/", true);
                        }
                        setTimeout(() => {
                            this.showDocToDisplay(r.result);
                        }, 500)
                    })
                else {
                    route("/", true);
                    this.showDocToDisplay(r.result);
                }
            }).catch(e => {
                this.modal.alert(e.errorMessage || e.message || e);
            });
    }

    private preCheck(): Promise<void> {
        var retval = new Promise<void>((res,rej) => {
            
            this.modal.showLoader(this.buildingService.getSigninOptions(this.props.buildingId))
                .then((r) => {
                    console.log(r);
                    //localStorage.setItem("buildingOptions", JSON.stringify(r.result));
                    var userType = this.auth.getUserType();
                    if (this.props.isSignIn) {
                        if (r.errorMessage) {
                            this.modal.alert(r.errorMessage);
                            rej();
                            return;
                        }
                        
                        if ((userType == UserTypeEnum.Contractor && !r.result.allowContractors) ||
                            (userType == UserTypeEnum.Tenant && !r.result.allowTenants) ||
                            (userType == UserTypeEnum.Visitor && !r.result.allowVisitors)) {
                            this.modal.alert(`Sorry, ${UserTypeEnum.getTextValue(userType)}s are not enabled for Sign-in at ${r.result.buildingName}.   If you are a different type of user, please click on the dots in the top right, forget your details, and register again`);
                            rej();
                            return;
                        }
                    }
                    if (!r.result.requireGpsLocationForContractors || userType != UserTypeEnum.Contractor) {
                        this.longitude = -1;
                        this.latitude = -1;
                        res();
                        return;  
                    }
                    if (navigator.geolocation) {
                        var options = {
                            enableHighAccuracy: true,
                            timeout: 5000,
                            maximumAge: 0
                        };
                        navigator.geolocation.getCurrentPosition((pos) => {
                            this.longitude = pos.coords.longitude;
                            this.latitude = pos.coords.latitude;
                            res();
                        }, () => { res(); }, options);
                    } else {
                        res();
                    }
                });
           
        });
        return retval;
    }

    componentDidMount() {
        
        this.preCheck().then(() => {
            this.modal.showLoader(this.signInOut(new SignInOutRequest({ buildingId: this.props.buildingId, latitude: this.latitude, longitude:this.longitude })))
            .then(r => {
                this.commonService.setHeaderImage(r.result.useHeaderImage);
                this.commonService.setFooterImage(r.result.useFooterImage);
                if (r.errorMessage) {
                    this.modal.alert(r.errorMessage);
                    return;
                }
                this.setState({ questions: r.result, isLoading: !r.result.questions.length });
                if (r.infoMessage)
                    this.modal.alert(r.infoMessage, () => {
                        if (!r.result.questions.length) {
                            route("/", true);
                            return;
                        }
                        setTimeout(() => {
                            this.showDocToDisplay(r.result);
                        }, 500)
                    })
                else {
                    if (!r.result.questions.length) {
                        route("/", true);
                        return;
                    }
                    this.showDocToDisplay(r.result);
                }
            }).catch(e => {
                this.modal.alert(e.errorMessage || e);
            })
        });
    }

    public showDocToDisplay(q: SignInOutQuestions) {
        var isPdf = q.docToDisplay.toLowerCase().indexOf("https://vimeo") == -1 && q.docToDisplay.toLowerCase().indexOf(".mp4") == -1;
        if (q.docToDisplay) {
            var allowClose = !q.docToDisplayMinNumOfSeconds;
            if (!allowClose) 
                setTimeout(() => {
                    allowClose = true; 
                }, q.docToDisplayMinNumOfSeconds * 1000);
            var start = (new Date()).getTime();
            var messageShown = false;
            this.modal.showMessageBox({
                message: this.getDocToDisplay(q.docToDisplay, isPdf),
                maxSize: isPdf,
                buttons: [
                    {
                        text: "Close and Continue",
                        onClick: () => {
                            if (allowClose) {

                                if (isPdf)
                                    this.refs.doc.destroy();
                                else
                                    this.refs.video.destroy();
                                this.modal.hideDialog();
                                return;
                            }
                            var timeout = q.docToDisplayMinNumOfSeconds * 1000 - ((new Date()).getTime() - start);
                            if (timeout > 0 && !messageShown) {
                                messageShown = true;
                                this.modal.showSnackBar({
                                    message: q.messageDocNotDisplayedLongEnough,
                                    timeout: timeout,
                                    actionText: 'Hide',
                                    actionHandler: () => {
                                        messageShown = false;
                                    }
                                });

                            }
                        }
                    }
                ]
            });
        }
    }

    public getDocToDisplay(url: string, isPdf: boolean) {
        if (isPdf)
            return <DocViewer ref={this.setRef("doc")} url={url} />;
        return <VideoPlayer ref={this.setRef("video")} url={url} playing />
    }

    render() {
        return (
            <div>
                {this.state.isLoading ? (<div></div>) : (
                    <div>
                        <h4 class="text-center" dangerouslySetInnerHTML={{ __html: this.state.questions.introMessage }} ></h4>
                        {this.props.isSignIn && this.props.buildingName ? (<h3 class="text-center">{this.props.buildingName}</h3>) : ("")}
                        <Questions ref={this.setRef('questions')} questions={this.state.questions.questions} />
                        <br />
                        <div class={`${style.formField}`}>
                            <Button raised ripple onClick={this.onSignInOut}>Continue</Button>
                        </div>

                    </div>
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./routes/signinout/signInOut.tsx